export const SUCCESS_CASE = 'success';
export const ERROR_CASE = 'error';